import { render, staticRenderFns } from "./hospitalizationType.vue?vue&type=template&id=36ed0ef1&"
import script from "./hospitalizationType.vue?vue&type=script&lang=js&"
export * from "./hospitalizationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports